const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isValidCertificateId = (value) => {
  const trimmed = value?.trim();

  return Boolean(trimmed) && UUID_REGEX.test(trimmed);
};

export const formatBirthdateForApi = (date) => {
  if (!date) {
    return "";
  }

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return "";
  }

  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
  const day = String(parsedDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getCertificateVerifyErrorMessage = (error, fallback) => {
  const status = error?.response?.status;
  const apiErrors = error?.response?.data?.errors;

  if (status === 400) {
    const fieldMessage = apiErrors?.[0]?.message;

    if (fieldMessage?.includes("UUID")) {
      return "Invalid certificate ID. Enter the full certificate UUID shown when the certificate was created.";
    }

    return (
      fieldMessage ||
      "Invalid certificate details. Please check and try again."
    );
  }

  if (status === 404) {
    return fallback || "No certificate found for the provided certificate ID and date of birth.";
  }

  if (status === 401 || status === 403) {
    return "Unable to verify certificate right now. Please try again later.";
  }

  if (status === 500) {
    return (
      apiErrors?.[0]?.message ||
      "Certificate verification failed on the server. Ask the backend team to check POST /certificates/verify."
    );
  }

  if (Array.isArray(apiErrors) && apiErrors[0]?.message) {
    return apiErrors[0].message;
  }

  return fallback;
};
